<template>
    <v-dialog
        v-model="dialog"
        max-width="70vh"
        @keydown.esc="cancel"
        :persistent="true"
    >
        <v-card>
            <v-toolbar dark color="primary" dense flat>
                <v-toolbar-title class="white--text">{{ $t("UserData.CHANGE_PASSWORD") }}</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
                <v-form ref="passwordForm">
                    <v-text-field
                        :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                        :rules="passwordRulse"
                        :type="showPassword ? 'text' : 'password'"
                        name="input-10-2"
                        :label="this.$t('UserData.NEW_PASSWORD')"
                        v-model="data.password"
                        maxlength="20"
                        counter="20"
                        @keyup="passwordChanged"
                        @change="passwordChanged"
                        @click:append="showPassword = !showPassword"
                        @keydown.space="preventLeadingSpace"
                    >
                    </v-text-field>
                    <v-text-field
                        ref="confirmPassword"
                        :append-icon="showConfirmPassword ? 'mdi-eye' : 'mdi-eye-off'"
                        :rules="confirmPasswordRulse"
                        :type="showConfirmPassword ? 'text' : 'password'"
                        name="input-10-2"
                        :label="this.$t('UserData.CONFIRM_NEW_PASSWORD')"
                        v-model="data.confirmPassword"
                        maxlength="20"
                        counter="20"
                        :disabled="allowDisabled"
                        @click:append="showConfirmPassword = !showConfirmPassword"
                        @keydown.space="preventLeadingSpace"
                    >
                    </v-text-field>
                </v-form>
            </v-card-text>
            <v-card-actions class="pt-0">
                <v-spacer></v-spacer>
                <v-btn color="primary" @click.native="submit" class="body-1">
                    {{ $t("SAVE") }}
                </v-btn>
                <v-btn color="error" @click.native="dialog = !dialog" class="body-1">
                    {{ $t("CANCEL") }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
    import serverTranslationsMixin from "@/mixins/serverTranslations.js";
    import generalFunctions from "@/mixins/generalFunctions";
    export default {
        name: "ad-change-password",
        mixins: [serverTranslationsMixin, generalFunctions],
        created(){
            this.dialog = true;
        },
        data() {
            return {
                data: {
                    password: "",
                    confirmPassword: "",
                },
                dialog: false,
                allowDisabled: true,
                passwordRulse: this.$store.state.rules.passwordRulse,
                confirmPasswordRulse: [
                    this.$store.state.rules.required,
                    v => v == this.data.password || this.$t("CONFIRM_PASSWORD_VALIDATION")
                ],
                showPassword: false,
                showConfirmPassword: false
            };
        },
        methods: {
            submit() {
                if (this.$refs.passwordForm.validate()) {
                    this.$http.post("/api/users/change_password/", this.data).then(
                        res => {
                            this.showToasted("success",this.serverTranslate(res.data.message));
                            this.dialog = false;
                        },
                        err => {
                            this.showToasted("error",this.serverTranslate(err.response.data.message));
                        }
                    );
                }
            },
            passwordChanged() {
                if (!this.data.password) {
                    this.allowDisabled = true;
                    this.$refs.confirmPassword.reset();
                } else {
                    this.allowDisabled = false;
                    this.$refs.confirmPassword.validate();
                }

            },
        }
    }
</script>